import React from "react";
import { MenuItem, Select } from "@material-ui/core";
import useGlobalContext from "../hooks/useGlobalContext";

const BusinessDropdown = props => {
  const {
    state: { associatedBusinesses }
  } = useGlobalContext();
  return (
    <Select
      disabled={associatedBusinesses.length < 2}
      fullWidth
      variant="outlined"
      {...props}
    >
      {associatedBusinesses.map(({id, legal_name: name, is_active: isActive}) => (
        <MenuItem disabled={!isActive} key={id} value={id}>
          {name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BusinessDropdown;
